export default __webpack_public_path__ + "static/media/logo apple 48dp.f23a7f52.svg";